import React from "react";
import { PrimaryButton } from "../BasicForm";

export const MinorReviewCard = props => (
  <li className="result-data">
    <dl className="minor-info">
      <dt className="body-bold">Minor:&nbsp;</dt>
      <dd className="body-bold">
        {props.firstName}&nbsp;{props.middleName}&nbsp;{props.lastName}
      </dd>
      <PrimaryButton
        label="Edit"
        className="link-style"
        options={props.id}
        handleClick={props.handleMinorEdit}
      />
      <div>
        <dt>Date of Birth:&nbsp;</dt>
        <dd>{props.dob}</dd>
      </div>
      <div>
        <dt>Last 4 of Minor's SSN:&nbsp;</dt>
        <dd>{props.ssn}</dd>
      </div>
      <div>
        <dt>Place of Birth:&nbsp;</dt>
        <dd>{props.placeOfBirth}</dd>
      </div>
      <div>
        <dt>Race:&nbsp;</dt>
        <dd>{props.getOptionName(props.race, props.race.value)}</dd>
      </div>
      <div>
        <dt>Sex:&nbsp;</dt>
        <dd>{props.getOptionName(props.sex, props.sex.value)}</dd>
      </div>
    </dl>
    {Object.keys(props.selectedOffenders).map(offenderId => {
      const offender = props.selectedOffenders[offenderId];
      return (
        <dl key={offenderId} className="minor-visit-info">
          <dt className="body-bold">Applying to Visit:&nbsp;</dt>
          <dd className="body-bold">{offender.FullName}</dd>
          <PrimaryButton
            label="Edit"
            className="link-style"
            options={props.id}
            handleClick={props.handleOffenderEdit}
          />
          <div>
            <dt className="accessibility-hidden">Location</dt>
            <dd>{offender.LocationName}</dd>
          </div>
        </dl>
      );
    })}
  </li>
);



// WEBPACK FOOTER //
// ./src/components/MinorReviewCard/MinorReviewCard.js